import cn from "date-fns/locale/zh-CN";
import moment from "moment";
import React, { useImperativeHandle, useState } from "react";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { userAddSubscription } from "../../api/adminApi";
import { dispatchAlertError, dispatchAlertSuc } from "../../app/godispatch";
import './AddUserPage.css';

const AddSubscriptionPage = React.forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        showMe,
        closeMe
    }))

    const initRequest = {
        description: '',
        type: '',
    }
    const [modalShow, setModalShow] = useState(false);
    const [loading, setLoading] = useState(false)
    const [userRequest, setUserRequest] = useState(initRequest)
    const [expireDate, setExpireDate] = useState();
    const [subTypes, setSubTypes] = useState([])
    const [userInfo, setUserInfo] = useState({})

    function closeMe() {
        setUserRequest(initRequest)
        setExpireDate(null)
        setModalShow(false);
    }

    function showMe(userInfo, subTypes) {
        setModalShow(true);
        setUserInfo(userInfo)
        setSubTypes(subTypes)
    }

    const createSubscription = () => {
        setLoading(true)
        // validate
        let currentParam = {}
        currentParam.userSubscriptionRequest = { ...userRequest }
        currentParam.userSubscriptionRequest.expireTime = moment(expireDate).toISOString()
        currentParam.username = userInfo.username
        if (!currentParam.username || !currentParam.userSubscriptionRequest.description || !currentParam.userSubscriptionRequest.expireTime) {
            dispatchAlertError('请填写完整')
            setLoading(false)
            return
        }

        // request
        userAddSubscription(currentParam)
            .then((res) => {
                setUserRequest(initRequest)
                dispatchAlertSuc('添加订阅成功')
                setTimeout(() => {
                    setLoading(false)
                    closeMe()
                }, 1000)
            })
            .catch(err => {
                dispatchAlertError(err)
                setLoading(false)
            })
    }

    return (
        <Modal ref={ref} show={modalShow} onHide={closeMe} animation={true} fullscreen={true} size="xl" backdrop={'static'} >
            <Modal.Header>
                <Modal.Title>新增订阅</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row>
                        <Col></Col>
                        <Col xs={9} md={4}>
                            <Form.Group>
                                <Form.Label>姓名</Form.Label>
                                <Form.Control value={userInfo.name} disabled />
                            </Form.Group>
                        </Col>
                        <Col></Col>
                    </Row>
                    <Row>
                        <Col></Col>
                        <Col xs={9} md={4}>
                            <Form.Group>
                                <Form.Label>用户名</Form.Label>
                                <Form.Control value={userInfo.username} disabled />
                            </Form.Group>
                        </Col>
                        <Col></Col>
                    </Row>
                    <Row>
                        <Col></Col>
                        <Col xs={9} md={4}>
                            <Form.Group>
                                <Form.Label>订阅类型</Form.Label>
                                <Form.Select aria-label="Default select example"
                                    onChange={e => setUserRequest(prevState => ({
                                        ...prevState,
                                        type: e.target.value === "" ? null : e.target.value
                                    }))}>
                                    <option key={2} value={null}>  </option>
                                    {subTypes}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col></Col>
                    </Row>
                    <Row>
                        <Col></Col>
                        <Col xs={9} md={4}>
                            <Form.Group>
                                <Form.Label>用户订阅有效期至</Form.Label>
                                <Form.Control as={DatePicker}
                                    selected={expireDate}
                                    onChange={(date) => setExpireDate(date)}
                                    minDate={moment().toDate()}
                                    selectsStart
                                    dateFormat="yyyy-MM-dd"
                                    locale={cn}
                                >
                                </Form.Control>
                                <Button variant="outline-primary"
                                    onClick={() => setExpireDate(moment().add(1, 'y').add(1, 'd').toDate())}>一年</Button>
                            </Form.Group>
                        </Col>
                        <Col></Col>
                    </Row>
                    <Row>
                        <Col></Col>
                        <Col xs={9} md={4}>
                            <Form.Group>
                                <Form.Label>用户订阅描述信息</Form.Label>
                                <Form.Control as="textarea" rows={3}
                                    value={userRequest.description}
                                    onChange={(e) => setUserRequest(
                                        prevState => ({
                                            ...prevState,
                                            description: e.target.value
                                        })
                                    )}
                                />
                            </Form.Group>
                        </Col>
                        <Col></Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Container>
                    <Row>
                        <Col></Col>
                        <Col xs={3} md={2}>
                            <Button variant="warning" onClick={createSubscription} disabled={loading}>确定</Button>
                        </Col>
                        <Col xs={3} md={2}>
                            <Button variant="secondary" onClick={closeMe} disabled={loading}>取消</Button>
                        </Col>
                    </Row>
                </Container>
            </Modal.Footer>
        </Modal>
    );
});

export default AddSubscriptionPage;